import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Grid2 as Grid, Skeleton, Typography } from "@mui/material";
import { Charity } from "../../../shared/types";
import { getCharity } from "../../../shared/utilities/actions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export interface ItemProps {
  ein: string;
  handleSelect: () => void;
}

export const Item = ({ ein, handleSelect }: ItemProps): React.JSX.Element => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const tablet = useMediaQuery(theme.breakpoints.down("lg"));
  let size: number = mobile ? 12 : tablet ? 4 : 3;

  const [busy, setBusy] = useState<boolean>(true);
  const [charity, setCharity] = useState<Charity | null>();

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let charityResponse: Charity = await getCharity(ein);
      setCharity(charityResponse);
      setBusy(false);
    };
    fetchData();
  }, []);

  if (!busy && charity) {
    return (
      <Grid
        container
        size={size}
        onClick={() => {
          handleSelect();
        }}
        sx={{
          "& img": { boxShadow: 3 },
          "& h5": { color: "#272643" },
          "& p": { borderLeft: "3px solid #272643" },
          "&:hover": {
            "& img": { boxShadow: 8 },
            "& h5": { color: "rgb(44, 105, 141)" },
            "& p": { borderLeft: "3px solid rgb(44, 105, 141)" },
          },
          paddingBottom: "24px",
          cursor: "pointer",
        }}
      >
        <Grid size={{ xs: 12 }}>
          <img
            src={charity.managed.displayBannerUrl}
            style={{ borderRadius: "24px", width: "100%", marginBottom: "6px" }}
          />
          <Typography variant="h5" style={{ marginTop: "16px" }}>
            {charity.managed.displayName}
          </Typography>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        size={size}
        sx={{
          "& img": { boxShadow: 3 },
          "& h5": { color: "#272643" },
          "& p": { borderLeft: "3px solid #272643" },
          "&:hover": {
            "& img": { boxShadow: 8 },
            "& h5": { color: "rgb(44, 105, 141)" },
            "& p": { borderLeft: "3px solid rgb(44, 105, 141)" },
          },
          paddingBottom: "24px",
        }}
      >
        <Grid size={{ xs: 12 }}>
          <Skeleton />
        </Grid>
      </Grid>
    );
  }
};
